
import { Vue } from "@/vue";
import Modal from "@/components/Modal.vue";
import { apiCall } from "@/lib/api";
import { mapGetters } from "vuex";
import { OtpToken } from "@/lib/types/OtpToken";
import MultiSelect from "@/components/MultiSelect.vue";
import { Season } from "@/lib/types/Season";
import UtilsMixin from "@/lib/mixins/utils";

export default Vue.extend({
  name: "JournalDialog",
  components: {
    Modal,
    MultiSelect,
  },
  mixins: [UtilsMixin],
  data() {
    return {
      otpToken: null as OtpToken | null,
      timer: null as NodeJS.Timeout | null,
      remainingTime: 0 as number,
      selectedSeason: null as Season | null,
      error: null as string | null,
    };
  },
  computed: {
    ...mapGetters(["currentFarmId", "seasons", "currentSeason"]),
    optionsSeasons(): Season[] {
      const seasons = Object.values(this.seasons).sort((a, b) => new Date(b.end_date).getTime() - new Date(a.end_date).getTime());
      const thisYear = new Date().getFullYear();
      const thisYearAndFutureSeasons = seasons.filter((season) => new Date(season.end_date).getFullYear() >= thisYear);
      if (thisYearAndFutureSeasons.length === 0) {
        this.$nextTick(() => {
          this.error = this.$gettext("No seasons available for this year. Please add a season for this year in crop rotation.");
        });
        return [];
      }
      return thisYearAndFutureSeasons;
    },
  },
  watch: {
    otpToken: {
      immediate: true,
      handler() {
        if (this.otpToken) {
          this.updateRemainingTime();
          if (this.timer) clearInterval(this.timer);
          this.timer = setInterval(this.updateRemainingTime, 1000);
        } else if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async getToken() {
      try {
        const token = await apiCall<OtpToken>("GET", `/farm/${this.currentFarmId}/season/${this.selectedSeason.id}/totp/`);
        this.otpToken = token;
        this.error = null;
      } catch (err) {
        this.error = this.$gettext("An unknown error occurred.");
        console.error(err);
      }
    },
    getSeasonLabel(season: Season) {
      return season.interval;
    },
    selectSeason(season: Season) {
      this.selectedSeason = season;
    },
    updateRemainingTime() {
      if (!this.otpToken) {
        this.remainingTime = 0;
        return;
      }
      const now = new Date().getTime();
      const validUntil = new Date(this.otpToken.valid_until).getTime();
      const diff = validUntil - now;
      if (diff <= 0) {
        this.remainingTime = 0;
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      } else {
        const seconds = Math.ceil(diff / 1000);
        this.remainingTime = seconds;
      }
    },
  },
});
